<template>
<div>
  <div class="agreement" v-html="agreement"></div>
  <van-loading v-if="loading" type="spinner"  class="loading"/>
</div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        agreement:'',
        loading:true
      }
    },
    mounted() {
      this.init();
    },
    methods:{
      init(){
        this.$reqGet('api/register/agreement',{type:'hide'}).then(res=>{
          this.loading = false;
          this.agreement = res.data.data.text;
        })
      }
    }
  }
</script>

<style lang="less" scoped>
.loading{
  margin: 100px auto;
}
.agreement{
  padding: 0 10px;
}
</style>
